export const EV_API_URL = 'https://my.embarkvet.com/api';
